const updateUrlParams = (paramsObject) => {
    if (typeof window !== "undefined") {
        const newParams = new URLSearchParams(window.location.search);

        // eslint-disable-next-line no-loops/no-loops, no-restricted-syntax
        for (const [key, value] of Object.entries(paramsObject)) {
            if (value === null || value === undefined) {
                newParams.delete(key);
            } else {
                newParams.set(key, value);
            }
        }

        const newQueryString = newParams.toString();
        const newUrl = newQueryString ? `${window.location.pathname}?${newQueryString}` : window.location.pathname; 
        window.history.replaceState(null, "", newUrl);
    }
};

export default updateUrlParams;
